import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import gravatar from '../utils/gravatar'
import { logoutRequest } from '../actions/index';
import '../assets/styles/components/Header.scss';
import logo from '../assets/static/logo-video.png';
import userIcon from '../assets/static/user-icon.png';

const Header = (props) => {

  const { user, isLogin, isRegister } = props;
  //valida si este objeto tiene más de un elemento. Se usa object.keys() para pasar el objeto a array y poder usar .length
  //para comparar o validar la cantidad de elementos que tiene dentro este objeto.
  const hasUser = Object.keys(user).length > 0;

  const handleLogout = () => {
    props.logoutRequest({})
  }
  
  //npm install classnames --save
  //Se encargará de cambiar la clase y el efecto visual que tiene nuestro header
  //De esta manera le paso una variable a className que tiene condiciones, que si se cumplen van a mostrar un valor u otro.
  const headerClass = classNames('header', {
    isLogin,
    isRegister,
  });

  return (
    <header className={ headerClass }>

      <Link to="/">
        <img className="header__img" src={logo} alt="Matías Video" />
      </Link>

      <div className="header__menu">
        <div className="header__menu--profile">

          {
            hasUser
              ? <img src={gravatar(user.email)} alt={user.email} />
              : <img src={userIcon} alt="user icon" />
          }

          <p>Perfil</p>
        </div>
        <ul>

          {
            hasUser
              ? <li><a href="/">{user.name}</a></li>
              : null
          }

          {
            hasUser
              ? <li><a href="#logout" onClick={ handleLogout }> Cerrar sesión </a></li>
              : <li><Link to="/login">Iniciar sesión</Link></li>
          }
          
        </ul>
      </div>
    </header>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  }
}

const mapDispatchToProps = {
  logoutRequest
}


export default connect(mapStateToProps, mapDispatchToProps)(Header);
